/* Dependencies */
import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Onboarding from './containers/Onboarding'
import { CHILE, PERU } from '../../constants'

const Components = ({ isLogged }) => {
    return (
        <Router>
            <Routes>
                <Route exact path="/onboarding" element={<Onboarding country={CHILE.value} />}/>
                <Route exact path="/onboarding/pe" element={<Onboarding country={PERU.value} />}/>
            </Routes>
        </Router>
    )
}

export default Components